window.lastPlate = '';

let lookupPlate = function() {
    let formElement = jQuery('.license-plate'),
        plate = formElement.val().trim(),
        responseElement = jQuery('.license-plate-lookup');

    if(window.lastPlate == plate) {
        return;
    }

    responseElement.text('');

    if(plate === '') {
        return;
    }

    window.lastPlate = plate;
    responseElement.text('Looking up (this can take a few seconds)');

    jQuery.post( '/apply-online/plate-lookup', {'plate': plate}, function(response) {
        responseElement.html(response);
        // handle error
    });

};


jQuery( document ).ready(function() {

    jQuery('.license-plate').on('keyup change blur keypress', debounce(lookupPlate, 750));

});